import { render, staticRenderFns } from "./ReviewPageView.vue?vue&type=template&id=1f043a70&scoped=true"
import script from "./ReviewPageView.vue?vue&type=script&lang=js"
export * from "./ReviewPageView.vue?vue&type=script&lang=js"
import style0 from "./ReviewPageView.vue?vue&type=style&index=0&id=1f043a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f043a70",
  null
  
)

export default component.exports